var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "home-footer" }, [
    _c("div", { staticClass: "flex-row w-wrapper container" }, [
      _c("div", { staticClass: "left" }, [
        _vm._m(0),
        _vm._m(1),
        _c("div", { staticClass: "flex-row-h-center" }, [
          _c(
            "span",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.goICP()
                },
              },
            },
            [_vm._v("互联网ICP备案：津ICP备2023009477号")]
          ),
          _c("img", {
            attrs: { src: require("@/assets/home/filing.png"), alt: "" },
          }),
          _c(
            "span",
            {
              staticStyle: { cursor: "pointer" },
              on: {
                click: function ($event) {
                  return _vm.goGA()
                },
              },
            },
            [_vm._v("津公网安备 10086000000号")]
          ),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "flex-row right" },
        [
          _c(
            "el-popover",
            {
              attrs: { placement: "top", width: "150", trigger: "hover" },
              model: {
                value: _vm.visible,
                callback: function ($$v) {
                  _vm.visible = $$v
                },
                expression: "visible",
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-center-row",
                  staticStyle: { width: "150px" },
                },
                [
                  _c("canvas", {
                    ref: "qrCanvas",
                    staticStyle: { width: "150px", height: "150px" },
                  }),
                ]
              ),
              _c(
                "div",
                {
                  staticClass: "flex-column app-item",
                  attrs: { slot: "reference" },
                  slot: "reference",
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/home/download.png"),
                      alt: "",
                    },
                  }),
                  _c("span", [_vm._v("下载APP")]),
                ]
              ),
            ]
          ),
          _c(
            "div",
            {
              staticClass: "flex-column app-item",
              on: {
                click: function ($event) {
                  return _vm.goWX()
                },
              },
            },
            [
              _c("img", {
                attrs: { src: require("@/assets/home/wechat.png"), alt: "" },
              }),
              _c("span", [_vm._v("官网微信")]),
            ]
          ),
          false
            ? _c("div", { staticClass: "flex-column app-item" }, [
                _c("img", {
                  attrs: { src: require("@/assets/home/weibo.png"), alt: "" },
                }),
                _c("span", [_vm._v("新浪微博")]),
              ])
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("公司名称：天津豆画视界科技有限公司")]),
      _c("span", { staticClass: "arco-divider arco-divider-vertical" }),
      _c("span", [
        _vm._v(
          "公司地址：天津市东丽区航双路与津滨快速路交口住所处东北侧航空商务中心7#-1,2,3,4,5,6,7-302,(3层-3501)"
        ),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [
      _c("span", [_vm._v("网络文化经营许可证：津网文（2024）0161-025号")]),
      _c("span", { staticClass: "arco-divider arco-divider-vertical" }),
      _c("span", [_vm._v("广播电视节目制作经营：（津）字第1761号")]),
      _c("span", { staticClass: "arco-divider arco-divider-vertical" }),
      _c("span", [_vm._v("增值电信业务经营许可证：津B2-20240061")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }